<template>
    <li>
        <img :src="`img/icons/64_${id}.png`" :alt="`${name} Icon`">
        <p>{{name}}</p>
    </li>
</template>

<script>
export default {
  props: ['name', 'id']
}

</script>

<style lang="scss" scoped>

li {
    clear: both;
    margin-bottom: 12px;
    overflow: auto;
}

img {
    width: 14px;
    margin-top: 2px;
    height: auto;
    float: left;
}

p {
    float: left;
    margin-left: 6px;
}
</style>
